import { Component } from 'preact';
import { ACCENT_GOLD, TEXT_PRIMARY } from '../../lib/medievalTheme';
import RewardCell from './RewardCell';
import DeckRewardCell from './DeckRewardCell';

// One row in the vertical Progression list. The row owns its level
// coin + reward cells; the vertical rail running the full column is
// drawn ONCE by the parent (ProgressionScreen) as a single absolute-
// positioned element behind all the rows, so the rail is continuous
// instead of segmented at row gaps.
//
// No transparency anywhere. Every color is solid per the rule.

const COIN_PALETTE = {
  current:   { rim: ACCENT_GOLD,  fill: 'radial-gradient(circle at 50% 32%, #4a3618 0%, #14100a 75%)', glyph: TEXT_PRIMARY },
  reached:   { rim: '#8a6322',    fill: 'radial-gradient(circle at 50% 32%, #3a2c14 0%, #14100a 75%)', glyph: '#c9a86a' },
  locked:    { rim: '#3a3328',    fill: 'radial-gradient(circle at 50% 32%, #1c1a14 0%, #0a0806 75%)', glyph: '#5b5247' },
};

export default class LevelRow extends Component {
  render() {
    const {
      level, isCurrent, isLocked,
      cells,
      sorceryCards, ownedDeckIds,
      onClaim,
    } = this.props;

    const coinTone = isCurrent ? 'current' : isLocked ? 'locked' : 'reached';
    const palette = COIN_PALETTE[coinTone];

    return (
      <div
        className="flex items-center"
        style={{
          gap: '1.5cqw',
          minHeight: '6cqw',
        }}
      >
        {/* Coin column. Fixed width so the rail (drawn by parent)
            aligns to all rows. */}
        <div
          style={{
            width: '4.2cqw',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            position: 'relative',
            zIndex: 2,
          }}
        >
          <div
            data-level={level}
            style={{
              width: '3.4cqw',
              height: '3.4cqw',
              borderRadius: '50%',
              background: palette.fill,
              border: `1.5px solid ${palette.rim}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: isCurrent
                ? [
                    `0 0 22px ${ACCENT_GOLD}`,
                    `inset 0 0 0 2px #5a4a26`,
                    'inset 0 1px 0 rgba(255, 220, 140, 0.35)',
                    'inset 0 -2px 4px rgba(0,0,0,0.65)',
                  ].join(', ')
                : [
                    `inset 0 0 0 1.5px ${isLocked ? '#231e16' : '#3a2c14'}`,
                    `inset 0 1px 0 rgba(255, 220, 140, ${isLocked ? '0.05' : '0.15'})`,
                    'inset 0 -2px 4px rgba(0,0,0,0.6)',
                    '0 2px 5px rgba(0,0,0,0.55)',
                  ].join(', '),
            }}
          >
            <span
              className="arena-heading font-bold tabular-nums"
              style={{
                fontSize: String(level).length >= 2 ? '1cqw' : '1.2cqw',
                lineHeight: 1,
                color: palette.glyph,
                textShadow: '0 1px 2px rgba(0,0,0,0.8)',
                filter: isCurrent ? `drop-shadow(0 0 6px ${ACCENT_GOLD})` : 'none',
              }}
            >
              {level}
            </span>
          </div>
        </div>

        {/* Reward cells lane. Always rendered (even empty) so the
            row's vertical rhythm stays constant. */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: '1.4cqw',
            minHeight: '5.4cqw',
          }}
        >
          {cells.map((c) => (
            c.type === 'deck' ? (
              <DeckRewardCell
                key="deck"
                level={level}
                state={c.state}
                lockedLevel={c.lockedLevel}
                sorceryCards={sorceryCards}
                ownedDeckIds={ownedDeckIds}
                onClaim={(origin) => onClaim(level, 'deck', origin)}
              />
            ) : (
              <RewardCell
                key={c.type}
                type={c.type}
                amount={c.amount}
                state={c.state}
                lockedLevel={c.lockedLevel}
                onClaim={(origin) => onClaim(level, c.type, origin)}
              />
            )
          ))}
        </div>
      </div>
    );
  }
}
